import {Component, OnInit, ViewChild} from "@angular/core";
import {catchError, tap, throwError} from "rxjs";
import {UtilService} from "../../services/util.service";
import {Router} from "@angular/router";
import {NgForm} from '@angular/forms';
import {AgencyService} from "src/app/services/agency.service";
import {UserInfoService} from "src/app/services/user-info.service";
import {ProtestInfoService} from "src/app/services/protest-info.service";
import {User, UserRole} from "../../models/user";
import {StateService} from "../../services/state.service";
import {EPDSFile} from "../../models/file-upload";
import {FileUploadService} from "../../services/file-upload.service";
import {PayGovOnlineResponse} from "../../models/protest";
import {AgencyTier2} from "../../models/agencies";
import {MatRadioChange} from "@angular/material/radio";
import PlaceResult = google.maps.places.PlaceResult;
import {FileUploadComponent} from "../file-upload/file-upload.component";

@Component({
    selector: 'app-protest-page',
    templateUrl: './protest-page.component.html',
    styleUrl: './protest-page.component.scss',
    standalone: false
})
export class ProtestPageComponent implements OnInit {
  @ViewChild('protestForm') form!: NgForm;
  @ViewChild('fileUpload', { static: false }) fileUpload!: FileUploadComponent;

  showProtestorInfo: boolean = true;
  a_num: string = '';
  user!: User;
  fileUploadInProgress: boolean = false;
  uploadDocMessage: string = 'Please upload the required documents';
  requiredFileType: string[] = ['png', 'jpg', 'pdf'];
  primaryFiles!: EPDSFile[];
  associatedFiles!: EPDSFile[];
  attachAssociatedDocOutput = false;
  Company_Address1: string;

  agencyT1DropdownOptions: Array<{ value: number, label: string }> = [];
  agencyT2DropdownOptions: Array<{ value: number | undefined, label: string | undefined }> = [];
  agency_tier_1: string = '';
  Company_Address2: string = '';
  Company_Zipcode: string = '';
  Company_City: string = '';
  Company_State: string = '';
  Company_Country: string = '';

  // Protester Representative Information (optional)
  email: string;
  firstname: string = '';
  lastname: string = '';
  phonenumber: string = '';
  faxnumber: string = '';
  address1: string = '';
  address2: string = '';
  zipcode: string = '';
  city: string = '';
  state: string = '';
  country: string = '';

  // Protest Detail
  solicitaion_Number: string = '';
  csolicitaion_Number: string = '';
  agency_tier_2: string = '';
  isDocConfidential: string = '';
  comments: string = '';
  isDropdownRequired: boolean = false;
  disableForm = false;


  constructor(private readonly util: UtilService,
              private readonly router: Router,
              private readonly agencyService: AgencyService,
              private readonly userInfoService: UserInfoService,
              private readonly protestInfoService: ProtestInfoService,
              private readonly fileUploadService: FileUploadService,
              private readonly stateService: StateService) {
    this.email = '';
    this.Company_Address1 = '';
  }

  ngOnInit(): void {
    this.user = this.stateService.user;
    this.showProtestorInfo = this.stateService.user.role_id === UserRole.GAO_Admin

    if (!this.showProtestorInfo) {
      this.disableForm = true;
      this.protestInfoService.testPayGov().subscribe(r => {
        // console.debug(r);

        if (r.isSuccess) {
          this.testPayGovSuccess();
        } else {
          this.testPayGovFail();
        }
      })
    }

    this.getAgencies();
    this.getProtestResponse();

    this.primaryFiles = [];
    this.associatedFiles = [];

    if (this.user.role_id === UserRole.Protester || this.user.role_id === UserRole.Intervenor) {
      this.uploadDocMessage = this.fileUploadService.udmPdfExcel;
      this.requiredFileType = this.fileUploadService.rftPdfExcel;
    } else if ((this.user.role_id === UserRole.Agency_Admin || this.user.role_id === UserRole.Agency_Attorney)) {
      this.uploadDocMessage = this.fileUploadService.udmPdfWordExcelZip;
      this.requiredFileType = this.fileUploadService.rftPdfWordExcelZip;
    } else if ((this.user.role_id === UserRole.GAO_Attorney || this.user.role_id === UserRole.GAO_Supervisor)) {
      this.uploadDocMessage = this.fileUploadService.udmPdfWordExcel;
      this.requiredFileType = this.fileUploadService.rftPdfWordExcel;
    } else if ((this.user.role_id === UserRole.GAO_Admin)) {
      this.uploadDocMessage = this.fileUploadService.udmPdfWordExcelZip;
      this.requiredFileType = this.fileUploadService.rftPdfWordExcelZip;
    } else {
      this.uploadDocMessage = "";
    }
  }

  fillCompanyAddressForm(place: PlaceResult): void {
    const addressComponents = place.address_components;

    let streetAddr = place.formatted_address?.split(",")[0]
    if (place.name !== streetAddr) {
      streetAddr = place.name + "," + streetAddr;
    }
    this.form.controls['company_address1'].patchValue(streetAddr);

    place.address_components?.forEach(component => {
      const types = component.types;
      if (types.includes('locality')) {
        this.form.controls['company_City'].patchValue(component.long_name);
      } else if (types.includes('administrative_area_level_1')) {
        this.form.controls['company_State'].patchValue(component.long_name);
      } else if (types.includes('country')) {
        this.form.controls['company_Country'].patchValue(component.long_name);
      } else if (types.includes('postal_code')) {
        this.form.controls['company_Zipcode'].patchValue(component.long_name);
      }
    });
  }

  fillProtesterAddressForm(place: PlaceResult): void {
    const addressComponents = place.address_components;

    let streetAddr = place.formatted_address?.split(",")[0]
    if (place.name !== streetAddr) {
      streetAddr = place.name + "," + streetAddr;
    }
    this.form.controls['address1'].patchValue(streetAddr);

    place.address_components?.forEach(component => {
      const types = component.types;
      if (types.includes('locality')) {
        this.form.controls['city'].patchValue(component.long_name);
      } else if (types.includes('administrative_area_level_1')) {
        this.form.controls['state'].patchValue(component.long_name);
      } else if (types.includes('country')) {
        this.form.controls['country'].patchValue(component.long_name);
      } else if (types.includes('postal_code')) {
        this.form.controls['zipcode'].patchValue(component.long_name);
      }
    });
  }

  private getFormData(formValues: any, user: User): FormData {
    const formData = new FormData();

    if (this.a_num != null || this.a_num != '') {
      formData.append('a_No', this.a_num);
    }

    if (user.role_id === UserRole.Protester) {
      if (user.address1 !== undefined) {
        formData.append('address1', user.address1);
      }

      if (user.address2 !== undefined) {
        formData.append('address2', user.address2);
      }

      if (user.country !== undefined) {
        formData.append('country', user.country)
      }

      formData.append('email', user.email)
      formData.append('firstname', user.first_Name)
      formData.append('lastname', user.last_Name)
      formData.append('phonenumber', user.phone_No)

      if (user.state !== undefined) {
        formData.append('country', user.state)
      }

      if (user.zip_Code !== undefined) {
        formData.append('country', user.zip_Code)
      }

      if (user.fax_No != null) {
        formData.append('faxnumber', user.fax_No);
      }
    }

    formData.append('typeOfProtest', 'protest')

    Object.keys(formValues).forEach(key => !formValues[key] && delete formValues[key]);
    Object.keys(formValues).forEach(key => {
      if (key !== 'csolicitaion_Number') {
        formData.append(key, formValues[key]);
      }
    });

    // console.debug(formValues);

    return formData;
  }

  onEPDSFileListChange(epdsFileList: EPDSFile[], typeOfList: string): void {
    // console.debug("EPDS File list for type %s: %O", typeOfList, epdsFileList);

    if (typeOfList === 'P') {
      this.primaryFiles = epdsFileList;
    } else {
      this.associatedFiles = epdsFileList;
    }

    // console.debug(this.primaryFiles);
    // console.debug(this.associatedFiles);
  }

  onSubmit(protestForm: any): void {
    // console.debug(protestForm.valid);
    // console.debug(protestForm.value);

    if (protestForm.valid) {
      protestForm.value.comments = this.util.removeCurlyQuotes(protestForm.value.comments);
      this.protestInfoService.validateProtestInfo(this.getFormData(protestForm.value, this.user)).subscribe(response => {
        // console.debug(response);
        if (response.inputErrors) {
          let message = "";
          response.inputErrors.forEach(inputErrors =>  message += inputErrors.fieldName + ": " + inputErrors.invalidValue + ", " + inputErrors.message + '<br>');
          this.util.displayDialogMessage("Input Errors", message);
        } else if (response.isSuccess) {
          if (!this.showProtestorInfo) {
            this.util.displayDialogMessage('Warning',
              'You will automatically be directed to Pay.gov to pay the filing fee. Your protest filing will not be complete until you have successfully made your payment. Upon successfully making your payment, you will automatically be returned to EPDS.gov. Once payment is made, you will not have the opportunity to edit your filing. You will automatically be directed to Pay.gov to pay the filing fee of $500.\n' +
              '<br><br>' +
              'Do you want to proceed to Pay.gov?',
              {
                cancelBtn: true,
                confirmText: 'Yes',
                cancelText: 'No',
                confirmButtonColor: 'primary',
                cancelButtonColor: 'warn',
                ignoreESC: false,
                height: 'auto'
              }).subscribe(res => {
                if (res) {
                  this.submitProcess(protestForm);
                }
            });
          } else {
            this.submitProcess(protestForm);
          }
        }
      });
    }
  }

  submitProcess(protestForm: any): void {
    const allFiles = [
      ...this.primaryFiles.map(epdsFile => ( { epdsFile, attachmentType: 'protest' })),
      ...(this.associatedFiles.map?.length ? this.associatedFiles.map(epdsFile => ( { epdsFile, attachmentType: 'associated' })) : [])
    ];

    // console.debug(allFiles);
    this.fileUploadInProgress = true;

    this.fileUploadService.submitFile(allFiles, this.a_num, this.fileUpload).pipe(
      tap(resp => console.log('Response from submitFile:', resp)),
      catchError(err => {
        // console.error('Error in submitFile:', err);
        this.fileUploadInProgress = false;

        return throwError(err);
      })
    ).subscribe(resp => {
      // console.debug(resp);
      this.protestInfoService.registerNewProtestInfo(this.getFormData(protestForm.value, this.user)).subscribe(res => {
        // console.debug(res);

        this.user = this.stateService.user;
        this.protestInfoService.setA_Num(this.a_num);

        if (!this.showProtestorInfo) {
          this.protestInfoService.payGovCollection(this.a_num).pipe(
            catchError(e => {
              console.error("Error in payGovCollection:", e);
              this.fileUploadInProgress = false;

              return throwError(e);
            })
          ).subscribe(r => {
            // console.debug("Response received:", r);
            this.fileUploadInProgress = false;

            if (r.payDotGovError && r.payDotGovError.errorCode === "4002") {
              this.util.displayDialogMessage("Error",
                "There seems to be an issue in the processing your request. Please try later.").subscribe(res => {
                this.router.navigate([this.util.getDashboardURL()]);
              });
            } else {
              this.pingPaymentUrl(r);
            }
          });
        } else {
          this.fileUploadInProgress = false;

          this.util.displayDialogMessage('Success!',
            'Filed New Protest.').subscribe(res => {
            this.router.navigate([this.util.getDashboardURL()]);
          });
        }
      });
    })
  }

  pingPaymentUrl(request: PayGovOnlineResponse): void {
    const token = request.payDotGovToken;
    const tcsAppID = request.payDotGovAppId;
    const paymentUrl = `${request.payDotGovPaymentUrl}token=${token}&tcsAppID=${tcsAppID}`;

    window.location.href = paymentUrl;
  }

  DocConfidentialChanged(event: MatRadioChange): void {
    const yesMsg = 'Because you have marked your protest as containing information that should be withheld from public disclosure, you are required to place a statement advising of that fact on the front page of the submission. 4 C.F.R. § 21.1(g).<br>Additionally, you must identify the information to be withheld wherever it appears, and file a redacted copy of the protest which omits the information, with GAO and the agency, within 1 day after filing the protest with GAO. Id.<br><br>Unless precluded by law, GAO will release any unmarked material to a requesting party outside the government, in accordance with GAO’s disclosure of records rules at 4 C.F.R. part 81.';
    const noMsg = 'Unless precluded by law, GAO will release any material not marked as protected to a requesting party outside the government, in accordance with GAO’s disclosure of records rules at 4 C.F.R. part 81.';
    const msg = (event.value === 'Y') ? yesMsg : noMsg;

    this.util.displayDialogMessage('Legal Information', msg, {width:"800px"}).subscribe();
  }

  onEmailChanged(event: any): void {
    const email = event.target.value;

    if (email) {
      this.userInfoService.getUserByEmail(email).subscribe(userInfoResp => {
        const userInfo = userInfoResp?.user_Info;

        if (userInfo) {
          this.form.controls['email'].setValue(userInfo.email);
          this.form.controls['firstname'].setValue(userInfo.first_Name);
          this.form.controls['lastname'].setValue(userInfo.last_Name);
          this.form.controls['phonenumber'].setValue(userInfo.phone_No);
          this.form.controls['faxnumber'].setValue(userInfo.fax_No);
          this.form.controls['address1'].setValue(userInfo.address1);
          this.form.controls['address2'].setValue(userInfo.address2);
          this.form.controls['zipcode'].setValue(userInfo.zip_Code);
          this.form.controls['city'].setValue(userInfo.city);
          this.form.controls['state'].setValue(userInfo.state);
          this.form.controls['country'].setValue(userInfo.country);

          this.form.controls['email'].setErrors(null)
        } else {
          this.form.controls['email'].setErrors({ unknown: true })
        }
      });
    }

  }

  getProtestResponse(): void {
    this.protestInfoService.getProtestResponse().subscribe(response => {
      // console.debug(response);

      this.a_num = response.aNum;
    });
  }

  onAgencyTier1Change(event: number): void {
    this.agencyService.getAgenciesTier2(event).subscribe(response => {
      // @ts-ignore - if there are no tier2 agencies 'empty' is returned despite being the wrong data type
      const tier2list: AgencyTier2[] = (typeof response?.tier2AgencyList === 'object') ? response.tier2AgencyList : [];

      this.agencyT2DropdownOptions = tier2list.map(agency => ({
          value: agency.agency_Id,
          label: agency.agency_Name
        }));
        this.isDropdownRequired = this.agencyT2DropdownOptions.length > 0;
    });
  }

  getAgencies() {
    this.agencyService.getAgencies().subscribe(response => {
      this.agencyT1DropdownOptions = response.AgencyTier1List.map(agency => ({
        value: agency.agency_Id,
        label: agency.agency_Name
      }));
    });
  }

  verifySolicitationNumber() {
    const solicitationCtrl= this.form.controls['solicitationNumber'];
    const csolicitationCtrl= this.form.controls['csolicitaion_Number'];

    if (solicitationCtrl.value && csolicitationCtrl.value) {
      if (solicitationCtrl.value === csolicitationCtrl.value) {
        csolicitationCtrl.setErrors(null);
      } else {
        csolicitationCtrl.setErrors({ unequal: true });
      }
    }

  }

  testPayGovSuccess() {
    const message = "Before filing a protest, you should carefully review our Bid Protest Regulations. " +
      "The Regulations are accessible by selecting the GAO logo at the top of the screen, which will redirect you to our website. " +
      "You should first select Bid Protests Appropriations Law, then select Our Process.<br><br>" +
      "You are strongly encouraged to review the following sections for important information:<br>" +
      "&emsp; § 21.1 Filing a protest;<br>" +
      "&emsp; § 21.2 Time for filing; and<br>" +
      "&emsp; § 21.5 Protest issues not for consideration.<br><br>" +
      "These sections include important information regarding what is necessary to include in your protest and what protests our Office will not consider. " +
      "No refunds of the filing fee will be made in the event a protest is dismissed for failing to comply with or otherwise does not meet the requirements set forth in our Bid Protest Regulations.<br><br>" +
      "Repeat - NO CLASSIFIED INFORMATION SHOULD BE FILED IN EPDS.<br><br>" +
      "For guidance on protests including classified material, please go to: <a href='http://gao.gov/legal/bid-protests/file-a-bid-protest'>http://gao.gov/legal/bid-protests/file-a-bid-protest</a><br><br>" +
      "Do you want to proceed to file a new protest?";

    this.util.displayDialogMessage('Warning', message,
      { cancelBtn: true, confirmText: 'Yes', cancelText: 'No', cancelButtonColor: 'warn', width: "800px",
              subtitle: "<b class='color_warn'>NO CLASSIFIED INFORMATION SHOULD BE FILED IN EPDS!</b>"}
    ).subscribe(confirmed => {
      if (!confirmed) {
        this.router.navigate([this.util.getDashboardURL()]);
      } else {
        this.disableForm = false;
      }
    });
  }

  testPayGovFail() {
    const message = "GAO endeavors to maintain the availability of EPDS during normal business hours, which are " +
      "Monday through Friday, 8:00 a.m. to 5:30 p.m. eastern time, excluding Federal holidays or when GAO’s Headquarters are otherwise closed.<br>" +
      "While EPDS is currently available, the Pay.Gov site which processes the required filing fee for new protests is currently unavailable.<br>" +
      "If you are unable to file a new protest in EPDS during normal business hours, please refer to the EPDS instructions available here: " +
      "<a href='http://gao.gov/legal/bid-protests/file-a-bid-protest'>http://gao.gov/legal/bid-protests/file-a-bid-protest</a>.<br>" +
      "If you are unable to file a new protest in EPDS during a period other than normal business hours, please attempt " +
      "to file the protest during the next period of normal business hours.<br>" +
      "All filings other than new protests must still be made in EPDS.";

    this.util.displayDialogMessage("Warning", message, {width: "800px"}).subscribe(confirmed => {
      this.router.navigate([this.util.getDashboardURL()]);
    });
  }

}
